import { render } from "./SaturdayChallengeModal.vue?vue&type=template&id=709eda6c"
import script from "./SaturdayChallengeModal.vue?vue&type=script&lang=js"
export * from "./SaturdayChallengeModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__